import { create } from 'zustand';
import type { InsuranceType } from '~/@types/insurance';
import { sendSalesFunnelStepUseCase } from '~/useCases/AssegurouAutoUseCases/SendSalesFunnelStepUseCase';
import { generateGuid } from '~/utils/auth';

const INITIAL_INFO: SalesFunnel.StepLogBody = {};

interface SalesFunnelState {
  insuranceType: InsuranceType | null;
  init: (insuranceType: InsuranceType) => void;
  info: SalesFunnel.StepLogBody;
  setInfos: (infos: SalesFunnel.StepLogBody) => void;
  newStepLog: (stepName: string) => void;
}

const updateInfo = (
  state: SalesFunnelState,
  field: keyof SalesFunnel.StepLogBody,
  value: any
): SalesFunnelState => {
  return {
    ...state,
    info: { ...(state.info || { ...INITIAL_INFO }), [field]: value },
  };
};

const useSalesFunnel = create<SalesFunnelState>((set, get) => ({
  insuranceType: null,
  info: INITIAL_INFO,
  init: (insuranceType) => {
    set({ insuranceType, info: INITIAL_INFO });
    set((state) => updateInfo(state, 'protocol', generateGuid()));
  },
  setInfos: (info) => {
    Object.entries(info).forEach(([key, value]) => {
      set((state) =>
        updateInfo(state, key as keyof SalesFunnel.StepLogBody, value)
      );
    });
  },
  newStepLog: async (stepName) => {
    await sendSalesFunnelStepUseCase(
      { stepName, type: get().insuranceType! },
      get().info
    );
  },
}));

export default useSalesFunnel;
